"use client";
import React from "react";
import styles from "./home.module.css";
import { useTranslations } from "next-intl";

const benefitKeys = [
  { icon: "🚀", key: "1" },
  { icon: "⚡", key: "2" },
  { icon: "🔒", key: "3" },
  { icon: "📱", key: "4" },
  { icon: "🎯", key: "5" },
  { icon: "✨", key: "6" },
];

export default function WhyChooseSection() {
  const t = useTranslations("home");
  return (
    <section className={styles.whyChooseSection}>
      <div className="container-md">
        <h2 className={styles.sectionTitle}>{t("whyChooseTitle")}</h2>
        <p className={styles.sectionDescription}>
          {t("whyChooseDescription")}
        </p>
        <div className={styles.benefitsGrid}>
          {benefitKeys.map(({ icon, key }, index) => (
            <div key={index} className={styles.benefitCard}>
              <div className={styles.benefitIcon}>{icon}</div>
              <h3 className={styles.benefitTitle}>{t(`benefit${key}Title`)}</h3>
              <p className={styles.benefitDescription}>{t(`benefit${key}Description`)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
